<template>
  <component
    :is="currentPath === result ? 'span' : 'a'"
    :href="currentPath === result ? null : result"
    class="logo"
  >
    <svg class="logo__icon"><use xlink:href="#svg-logo"></use></svg>
  </component>
</template>

<script>
export default {
  name: 'Logo',
  props: ['result'],
  data() {
    return {
      currentPath: location.pathname,
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  svg {
    width: 78px;
    height: 36px;
    @include point-lg {
      width: 100px;
      height: 46px;
    }
  }
}
</style>
